import {Component, EventEmitter, OnInit, Output} from '@angular/core';
import {UiService} from '../../../services/ui.service';
import {UntypedFormArray, UntypedFormBuilder, UntypedFormGroup} from '@angular/forms';
import {StaticDataService} from '../../../services/static-data.service';
import {EnumValidValueItemModel} from '../../../models/enum/enum-valid-value-item.model';
import {SchedulingService} from '../../scheduling/scheduling.service';
import {MatSnackBar} from '@angular/material/snack-bar';
import {
    CheckoutProcessorConfigurationService
} from '../../configuration/checkout-processor-configuration/checkout-processor-configuration.service';
import {Globals} from '../../../globals';
import {CfgAutoCheckOutModel} from '../../../models/configuration/cfg-task-auto-checkout.model';
import {MessagingConstants} from '../../../models/MessagingConstants';
import {SignalrService} from '../../../services/socket/signalr.service';
import {LocalStorageService} from '../../../services/local-storage.service';
import {Router} from '@angular/router';
import {MatDialog, MatDialogConfig} from '@angular/material/dialog';
import {CheckOutAdaClaimDialogComponent} from './check-out-ada-claim-dialog/check-out-ada-claim-dialog.component';
import { TaskManagementDialogComponent
} from '../../../dialog/tasks/task-management-dialog/task-management-dialog.component';
import {UserService} from '../../../services/user.service';
import {CaseFormsService} from '../case-forms.service';
import {MessagingService} from '../../../services/messaging.service';
import {Subscription} from 'rxjs';
import { PrintLedgerParamsModel } from 'src/app/models/accountsReceivable/print-ledgerParams.model';
import { ReportIDEnum } from 'src/app/models/enum/report-ID-enum';
import { TDOPrintService } from 'src/app/services/print/tdoprint.service';

enum CheckOutTaskIcon {
    Feespage        = 'assignment',
    EnterPayment    = 'monetization_on',
    SetReminder     = '',   // 'access_time',
    Ledger          = '',   // 'assignment_ind',
    Walkoutslip     = '',   // 'print',
    AutoADA         = 'disc_full',
    Rx              = 'style',
    LetterstoSend   = 'send',
    MarkPatientasOut= '' // 'transfer_within_a_station',
}
interface IconDefinition {
    name: string;
    show: boolean;
    toolTip: string;
}

@Component({
  standalone: false,
    selector: 'app-check-out',
    templateUrl: './check-out.component.html',
    styleUrls: ['./check-out.component.scss']
})
export class CheckOutComponent implements OnInit {
    checkOutTasksEnums: EnumValidValueItemModel[] = [];
    OriginalCheckOutProcessor: CfgAutoCheckOutModel[] = [];
    selectedCheckOutTask: EnumValidValueItemModel[] = [];
    messagingSubscription: Subscription;
    selectedAppt: any;
    checkOutInformation: any;
    isLoadingCheckOutData: boolean = true;
    isIconVisible: boolean = false;
    showTextIcon: string = '';

    enumAutoCheckOutTasksFeespage: string = '00000266-1000-0000-0000-000000000001';
    enumAutoCheckOutTasksEnterPayment: string = '00000266-1000-0000-0000-000000000002';
    enumAutoCheckOutTasksSetReminder: string = '00000266-1000-0000-0000-000000000003';
    enumAutoCheckOutTasksLedger: string = '00000266-1000-0000-0000-000000000004';
    enumAutoCheckOutTasksWalkoutslip: string = '00000266-1000-0000-0000-000000000005';
    enumAutoCheckOutTasksAutoADA: string = '00000266-1000-0000-0000-000000000006';
    enumAutoCheckOutTasksRx: string = '00000266-1000-0000-0000-000000000007';
    enumAutoCheckOutTasksLetterstoSend: string = '00000266-1000-0000-0000-000000000008';
    enumAutoCheckOutTasksMarkPatientasOut: string = '00000266-1000-0000-0000-000000000009';

    myForm: UntypedFormGroup;
    buttonId: string;
    iconName: string;
    IndexNext: number = 0;
    icon: IconDefinition[] = [];
    buttonAction: string[] = [];
    actionDone: boolean[] = [];

    @Output() closeCheckOut =  new EventEmitter();

    constructor(public uiService: UiService,
                private staticDataService: StaticDataService,
                private fb: UntypedFormBuilder,
                private scheduleService: SchedulingService,
                private snackBar: MatSnackBar,
                private checkOutProcessorConfigService: CheckoutProcessorConfigurationService,
                private globals: Globals,
                private signalrService: SignalrService,
                private localStorageService: LocalStorageService,
                private router: Router,
                private dialog: MatDialog,
                private userService: UserService,
                private caseService: CaseFormsService,
                private messagingService: MessagingService,
                private readonly printService: TDOPrintService) { }

    ngOnInit(): void {
        this.myForm = this.fb.group({
            checkOutProcedure: this.fb.array([])
        });
        if (!this.staticDataService.isReady) {
            this.staticDataService.validValuesReadyEvent.subscribe({
                complete: () => {
                    this.setupPage();
                }
            });
        } else {
            this.setupPage();
        }
        this.uiService.isCheckOutViewMinimized = false;
        this.uiService.isCaseViewMinimized = true;

        this.router.events.subscribe((data) => {
            if (this.uiService.isCheckOutViewMinimized) {
                this.resetCheckOutView();
            }
        });

        this.messagingSubscription = this.messagingService.componentMessageCall
            .subscribe(response => {
                if (response.event === MessagingConstants.PATIENT_CHANGED && response.data.PatientID !== this.selectedAppt.PatientId) {
                  this.closeCheckOut.emit();
                }
            });
    }

    setupPage(){
        this.checkOutTasksEnums = this.staticDataService.getValidValueItemsByValidValueName('enumAutoCheckOutTasks');
        this.selectedAppt = JSON.parse(localStorage.getItem('selectedAppt'));
        this.scheduleService.getCheckOutInformation(this.selectedAppt.PatientId).
            subscribe(response => {
                this.checkOutInformation = response;
                this.getCheckOutTask();
            }, err => {
                this.showMessage('Error', 'Error getting Check Out Data');
            });
    }


    resetCheckOutView(): void {
        this.uiService.isCheckOutViewMinimized = false;
        this.uiService.isCaseViewMinimized = true;
    }

    async getCheckOutTask() {
        const promises: any[] = [
            this.checkOutProcessorConfigService.getCheckOutProcessor(this.globals.LOCID).toPromise()
        ];
        const results: any[] = await Promise.all(promises);
        this.OriginalCheckOutProcessor = results[0];

        let i: number = 0;
        for (const item of this.OriginalCheckOutProcessor) {
            const checkOutProcedure = this.fb.group({
                checkOutProcedure: []
            });
            this.selectedCheckOutTask[i] =   this.checkOutTasksEnums.find(({ ValidValueItemId }) => ValidValueItemId === item.enumAutoCheckOutTasksID);
            this.isIconVisible = true;
            switch (item.enumAutoCheckOutTasksID) {
            case this.enumAutoCheckOutTasksFeespage:
                this.iconName =  CheckOutTaskIcon.Feespage;
                this.buttonId = this.enumAutoCheckOutTasksFeespage;
                this.isIconVisible = this.checkOutInformation.showFeesIcon;
                this.showTextIcon = 'There is no charge for today';
                break;
            case this.enumAutoCheckOutTasksEnterPayment:
                this.iconName = CheckOutTaskIcon.EnterPayment;
                this.buttonId = this.enumAutoCheckOutTasksEnterPayment;
                this.isIconVisible = this.checkOutInformation.showPaymentIcon;
                this.showTextIcon = 'Balance is > 0';
                break;
            case this.enumAutoCheckOutTasksSetReminder:
                this.iconName = CheckOutTaskIcon.SetReminder;
                this.buttonId = this.enumAutoCheckOutTasksSetReminder;
                break;
            case this.enumAutoCheckOutTasksLedger:
                this.iconName = CheckOutTaskIcon.Ledger;
                this.buttonId = this.enumAutoCheckOutTasksLedger;
                break;
            case this.enumAutoCheckOutTasksWalkoutslip:
                this.iconName = CheckOutTaskIcon.Walkoutslip;
                this.buttonId = this.enumAutoCheckOutTasksWalkoutslip;
                break;
            case this.enumAutoCheckOutTasksAutoADA:
                this.iconName = CheckOutTaskIcon.AutoADA;
                this.buttonId = this.enumAutoCheckOutTasksAutoADA;
                this.isIconVisible = this.checkOutInformation.showADAIcon;
                this.showTextIcon = 'NO insurance specified';
                break;
            case this.enumAutoCheckOutTasksRx:
                this.iconName = CheckOutTaskIcon.Rx;
                this.buttonId = this.enumAutoCheckOutTasksRx;
                this.isIconVisible = this.checkOutInformation.showRxIcon;
                break;
            case this.enumAutoCheckOutTasksLetterstoSend:
                this.iconName = CheckOutTaskIcon.LetterstoSend;
                this.buttonId = this.enumAutoCheckOutTasksLetterstoSend;
                this.isIconVisible = this.checkOutInformation.showLettersIcon;
                this.showTextIcon = 'Any letters to send ';
                break;
            case this.enumAutoCheckOutTasksMarkPatientasOut:
                this.iconName = CheckOutTaskIcon.MarkPatientasOut;
                this.buttonId = this.enumAutoCheckOutTasksMarkPatientasOut;
                break;
            }
            const iconValue = {} as IconDefinition;
            iconValue.name = this.iconName;
            iconValue.show = this.isIconVisible;
            iconValue.toolTip = this.showTextIcon;
            this.showTextIcon = '';
            this.checkOutProcedureForms.push(checkOutProcedure);
            this.icon.push(iconValue);
            this.buttonAction.push(item.enumAutoCheckOutTasksID);
            this.actionDone.push(true);
            i++;
        }
        this.isLoadingCheckOutData = false;
    }

    get checkOutProcedureForms(){
        return this.myForm.get('checkOutProcedure') as UntypedFormArray;
    }


    AddFunction(checkOutTask: string, index: number){
        switch (checkOutTask) {
        case this.enumAutoCheckOutTasksFeespage:
            this.actionTasksFeespage();
            break;
        case this.enumAutoCheckOutTasksEnterPayment:
            this.actionTasksEnterPayment();
            break;
        case this.enumAutoCheckOutTasksSetReminder:
            this.actionTasksSetReminder();
            break;
        case this.enumAutoCheckOutTasksLedger:
            this.actionTasksLedger();
            break;
        case this.enumAutoCheckOutTasksWalkoutslip:
            this.actionTasksWalkoutslip();
            break;
        case this.enumAutoCheckOutTasksAutoADA:
            this.actionTasksAutoADA();
            break;
        case this.enumAutoCheckOutTasksRx:
            this.actionTasksRx();
            break;
        case this.enumAutoCheckOutTasksLetterstoSend:
            this.actionTasksLetterstoSend();
            break;
        case this.enumAutoCheckOutTasksMarkPatientasOut:
            this.actionTasksMarkPatientAsOut();
            break;
        }
        this.IndexNext = index + 1; // set next index based on action
        this.actionDone[index] = false;
    }

    actionTasksFeespage(){
        this.router.navigateByUrl('landing/fees');
    }
    actionTasksEnterPayment(){
        this.router.navigate(['landing/ledger'], { queryParams: { isCheckOut: true } });
    }
    actionTasksSetReminder(){
        const config = new MatDialogConfig();
        config.panelClass = 'dialog';
        this.dialog.open(TaskManagementDialogComponent, config);
    }
    actionTasksLedger(){
       this.router.navigateByUrl('landing/ledger');
    }

    async actionTasksWalkoutslip(){
          const PrintParameters = new PrintLedgerParamsModel();
          PrintParameters.EnterpriseID = localStorage.getItem('TDOEnterpriseId');
          PrintParameters.LOCID = parseInt(this.globals.LOCID, 10);
          PrintParameters.PatientID = this.selectedAppt.PatientId;
          PrintParameters.ReportId = ReportIDEnum.reportID_FrontDesk_WalkOutSlip;
          PrintParameters.UserId = this.localStorageService.currentUserData.authdata.userid;
            try {
                  let documentID = await this.printService.printReport( ReportIDEnum.reportID_FrontDesk_WalkOutSlip, PrintParameters).toPromise();
                  this.printService.executePrint([documentID]);
                }
            catch (error) {
              this.showMessage('Error when trying to print Document.', 'error');
            }
    }

    actionTasksAutoADA(){
        const dialogRef = this.dialog.open(CheckOutAdaClaimDialogComponent, {
            width: '30%',
            panelClass: 'dialog'
        });
        dialogRef.afterClosed().subscribe(result => {
        }, err => {
        });
    }
    actionTasksRx(){
        this.uiService.isCheckOutViewMinimized = false;
        this.router.navigateByUrl('landing/erx');
    }
    actionTasksLetterstoSend(){
        this.uiService.openLettersWindow();
    }
    actionTasksMarkPatientAsOut(){
        this.caseService.setCheckOutComplete(this.selectedAppt.AppointmentId)
            .subscribe((response: any) => {
                // completed check out
                this.showMessage('Message', 'Check out Complete');
                this.closeCheckOutView();

            }, err => {
                this.showMessage('Error', 'Problem completing Check Out');
            });
    }
    showNotesToFront(){
        this.uiService.isCheckOutViewMinimized = false;
        this.router.navigateByUrl('landing/notes-to-front');
    }

    executeNextStep(){
        this.AddFunction(this.selectedCheckOutTask[this.IndexNext].ValidValueItemId, this.IndexNext);
    }
    closeCheckOutView(){
        this.router.navigateByUrl('landing/case-view').then(() => {
            this.messagingService.broadCastMessage(MessagingConstants.CHECKOUT_PATIENT_COMPLETED, {
                appointmentId: this.selectedAppt.AppointmentId,
            });
        });
        this.closeCheckOut.emit();
    }

    showMessage(type, message) {
        this.snackBar.open(message, type, {
            duration: 3000,
            verticalPosition: 'top'
        });
    }
}
